import { Injectable } from '@angular/core';
import { FluxRequestGateway } from './flux-request-gateway';

@Injectable({ providedIn: 'root' })
export class QueryGatewayService extends FluxRequestGateway {
  protected path = '/query';
}
